




































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { InternalSite, SiteRole, siteAdminRoleApis, roleType, adminType, RoleMembers, InvalidParam } from '../../api';
import EmployeeSelectM from '@/components/vantM/EmployeeSelectM.vue';
import DepartmentSelectM from '@/components/vantM/DepartmentSelectM.vue';

@Component({ components: { EmployeeSelectM, DepartmentSelectM } })
export default class SiteRolesTable extends Vue {
  @Prop() tabValue!: string;
  @Ref('employee-select-m') EmployeeSelectM!: EmployeeSelectM;

  roles: Array<SiteRole> = [];
  showRoles = [];
  loading = false;
  dialogLoading = false;
  finished = false;
  dialogFinished = false;
  siteId = 0;
  membersDialogShow = false;
  RoleDialogShow = false;
  EmployeeDialogShow = false;
  DepartmentDialogShow = false;
  roleType = 'employees';
  errors = {};
  members: RoleMembers | [] = [];
  selectRole: SiteRole = { id: 0, status: 0, site_id: 0, name: '', title: '' };
  targetId: string | number = '';
  departmentTargetId: string | number = '';

  watchParams() {
    return [this.$route, this.tabValue];
  }

  async mounted() {
    this.$watch(this.watchParams, this.refreshRoles);
    await this.refreshRoles();
  }

  async refreshRoles() {
    const routeSiteId = parseInt(this.$route.params.id);
    if (Number.isInteger(routeSiteId)) {
      this.siteId = routeSiteId;
    }
    if (this.tabValue == 'perm_role') {
      this.loading = true;
      this.finished = false;
      this.roles = [];
      try {
        this.roles = await siteAdminRoleApis.getRoles(this.siteId, roleType[this.tabValue]);
      } finally {
        this.loading = false;
        this.finished = true;
      }
    }
  }

  async deleteRole(role: SiteRole) {
    await this.$dialog.confirm({ message: `确定删除角色${role.title}吗?` }).then(() => {
      siteAdminRoleApis.deleteRole(this.siteId, role.id);
      const idx = this.roles.findIndex(r => r.id === role.id);
      if (idx >= 0) {
        this.roles.splice(idx, 1);
      }
      this.$toast.success(`删除角色[${role.title}]成功`);
    });
  }

  get site(): InternalSite {
    return this.$store.getters['sites/getSite'](this.siteId);
  }

  getPerm(type: string) {
    const perm = adminType[type];
    return this.site.perms.indexOf(perm) > -1;
  }

  async showMembersDialog(role: SiteRole, type: string) {
    this.roleType = type;
    this.selectRole = role;
    this.membersDialogShow = true;
    await this.getRoleMembers();
  }

  showRoleEditDialog(role: SiteRole | null) {
    if (role) {
      this.selectRole = role;
    } else {
      this.selectRole = { site_id: this.siteId } as SiteRole;
    }
    this.RoleDialogShow = true;
  }

  async getRoleMembers() {
    this.dialogLoading = true;
    this.dialogFinished = false;
    this.members = [];
    siteAdminRoleApis
      .getRoleMembers(this.siteId, this.selectRole.id)
      .then(members => {
        this.members = members;
      })
      .finally(() => {
        this.dialogLoading = false;
        this.dialogFinished = true;
      });
  }

  async save() {
    try {
      if (this.selectRole) {
        const role = await siteAdminRoleApis.saveRole(this.selectRole, roleType[this.tabValue]);
        const idx = this.roles.findIndex(r => r.id === role.id);
        if (idx >= 0) {
          Vue.set(this.roles, idx, role);
        } else {
          this.roles.push(role);
        }
        this.$toast.success(`保存角色[${role.title}]成功`);
      }
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$toast.fail(e.message);
      }
    }
  }

  async updateRoleEmployees(employee_id: number, checked: boolean) {
    if (this.selectRole) {
      this.members = await siteAdminRoleApis.updateRoleMember({
        siteId: this.siteId,
        roleId: this.selectRole.id,
        checked: checked,
        employeeId: employee_id
      });
      this.$toast.success(`保存数据成功`);
    }
  }

  async updateRoleDepartments(department_id: number, checked: boolean) {
    if (this.selectRole) {
      this.members = await siteAdminRoleApis.updateRoleMember({
        siteId: this.siteId,
        roleId: this.selectRole.id,
        checked: checked,
        departmentId: department_id
      });
      this.$toast.success(`保存数据成功`);
    }
  }
}
